module.exports = __webpack_public_path__ + "img/film.67c25e.svg";